const ClientLanguage = () => {
	var userLanguage = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

	var splitted = userLanguage.split('-');

	var shortCode = splitted[0];
	//default language EN
	var languageCodeInformation = {
		SingleLanguageCode: 'en',
		CompleteLanguageCode: 'en-US'
	};

	if (shortCode === 'nl') {
		languageCodeInformation.SingleLanguageCode = 'nl';
		languageCodeInformation.CompleteLanguageCode = 'nl-NL'
	}

	return languageCodeInformation
};

export default (ClientLanguage);


// WEBPACK FOOTER //
// ./src/utils/ClientLanguage.js